import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import axios from "axios";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Mousewheel, Navigation, Keyboard } from "swiper/modules";

export default function CatelogPreview() {
  const containerStyle = {
    position: "relative",
    display: "inline-block",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "80vh",
    marginTop: "22px",
  };

  const textStyle = {
    position: "absolute",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    color: "white",
    padding: "5px 10px",
    borderRadius: "5px",
  };

  const imageStyle = {
    width: "50vw",
    height: "40vw",
    maxHeight: "100%",
    objectFit: "cover",
  };

  const [data, setData] = useState([]);
  const [index, setIndex] = useState(0);
  const [editableTexts, setEditableTexts] = useState({});
  const swiperRef = useRef(null);

  const fetchData = async () => {
    const apiUrl = "https://157.90.147.8:5170/api/category/getCampaigndata";

    try {
      const response = await axios.get(apiUrl);
      if (response.data && Array.isArray(response.data.data)) {
        setData(response.data.data.sort((a, b) => a.position - b.position));
        const initialTexts = {};
        response.data.data.forEach((item) => {
          initialTexts[item._id] = item.images.map(() => "Your Text Here");
        });
        setEditableTexts(initialTexts);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // Add event listener for keydown events
    const handleKeyDown = (event) => {
   
      if (event.key === "ArrowUp") {
        handleUpClick(); // Call handleUpClick when ArrowUp is pressed
      } 
      if (event.key === "ArrowDown") {
        handleDownClick();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup event listener when component is unmounted
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleUpClick = () => {
    setIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0));
  };

  const handleDownClick = () => {
    setIndex((prevIndex) =>
      prevIndex < data.length - 1 ? prevIndex + 1 : prevIndex
    );
  };

  return (
    <div style={{ position: "relative", padding: "20px" }}>
      {data.slice(index, index + 1).map((item) => (
        <div key={item._id} style={{ marginBottom: "30px" }}>
          <Swiper
            ref={swiperRef}
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            mousewheel={true}
            keyboard={true}
            navigation={true}
            modules={[Autoplay, Navigation, Keyboard, Mousewheel]}
            className="mySwiper"
          >
            {item.images.map((image, imgIndex) => (
              <SwiperSlide key={imgIndex}>
                <div style={containerStyle}>
                  <img
                    style={imageStyle}
                    src={image}
                    alt={`Image ${imgIndex + 1}`}
                  />
                  <label style={textStyle}>
                    {editableTexts[item._id][imgIndex]}
                  </label>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Up Arrow Button */}
          <div
            style={{
              position: "absolute",
              top: "10%",
              left: "49%",
              transform: "translate(-50%, -100%)",
              zIndex: 10,
            }}
          >
            <button onClick={handleUpClick}>
              <svg
                height="70"
                viewBox="0 0 512 512"
                width="70"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polygon
                  points="396.6,352 416,331.3 256,160 96,331.3 115.3,352 256,201.5"
                  fill="blue"
                />
              </svg>
            </button>
          </div>

          {/* Down Arrow Button - Conditionally Visible */}
          {index < data.length - 2 && (
            <div
              style={{
                position: "absolute",
                top: "73%",
                left: "49%",
                transform: "translate(-50%, 100%)",
                zIndex: 10,
              }}
            >
              <button onClick={handleDownClick} style={buttonStyle}>
                <svg
                  height="70"
                  width="70"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <polygon
                    points="396.6,160 416,180.7 256,352 96,180.7 115.3,160 256,310.5"
                    fill="blue"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

// Modal styles
const modalStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalContentStyle = {
  backgroundColor: "white",
  padding: "20px",
  borderRadius: "5px",
  width: "300px",
  textAlign: "center",
};

// Button style
const buttonStyle = {
  color: "white",
  border: "none",
  padding: "10px",
  cursor: "pointer",
  borderRadius: "5px",
  fontSize: "18px",
  width: "50px",
  textAlign: "center",
};
